// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextFormattingMenuButton__button-a8f475 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 36px;
  height: 36px;
  text-align: center;
  cursor: pointer;
  border-radius: 8px;
  background-color: var(--background-color);
}

.TextFormattingMenuButton__button-a8f475:hover {
  background-color: var(--background-color-hover);
}

.TextFormattingMenuButton__button-a8f475:focus-visible {
  background-color: var(--background-color-focus);
}

.TextFormattingMenuButton__button-a8f475:active {
  background-color: var(--background-color-active);
}

.TextFormattingMenuButton__button-a8f475:disabled {
  background-color: var(--background-color-disabled);
  cursor: default;
}

.TextFormattingMenuButton__button-a8f475 .TextFormattingMenuButton__icon-d25ab9 {
  fill: var(--color-icon);
}

.TextFormattingMenuButton__button-a8f475:disabled .TextFormattingMenuButton__icon-d25ab9 {
  fill: var(--color-icon-disabled);
}

.TextFormattingMenuButton__theme-1-d793cc {
  --background-color: transparent;
  --background-color-hover: var(--base-15);
  --background-color-focus: var(--base-15);
  --background-color-active: var(--base-17);
  --background-color-disabled: transparent;
  --color-icon: var(--base-120);
  --color-icon-disabled: var(--base-120);
}

.TextFormattingMenuButton__theme-2-e18968 {
  --background-color: var(--brand-primary-0);
  --background-color-hover: var(--brand-primary-0);
  --background-color-focus: var(--brand-primary-0);
  --background-color-active: var(--brand-primary-0);
  --background-color-disabled: transparent;
  --color-icon: var(--base-120);
  --color-icon-disabled: var(--base-120);
}

.TextFormattingMenuButton__theme-3-fdc175 {
  --background-color: transparent;
  --background-color-hover: var(--brand-primary-0);
  --background-color-focus: var(--brand-primary-0);
  --background-color-active: var(--brand-primary-10);
  --background-color-disabled: transparent;
  --color-icon: var(--danger-40);
  --color-icon-disabled: var(--danger-10);
}`, "",{"version":3,"sources":["webpack://./src/components/TextFormattingInput/TextFormattingMenu/components/TextFormattingMenuButton/TextFormattingMenuButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;AACF;;AAEA;EACE,+CAAA;AACF;;AAEA;EACE,+CAAA;AACF;;AAEA;EACE,gDAAA;AACF;;AAEA;EACE,kDAAA;EACA,eAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,+BAAA;EACA,wCAAA;EACA,wCAAA;EACA,yCAAA;EACA,wCAAA;EACA,6BAAA;EACA,sCAAA;AACF;;AAEA;EACE,0CAAA;EACA,gDAAA;EACA,gDAAA;EACA,iDAAA;EACA,wCAAA;EACA,6BAAA;EACA,sCAAA;AACF;;AAEA;EACE,+BAAA;EACA,gDAAA;EACA,gDAAA;EACA,kDAAA;EACA,wCAAA;EACA,8BAAA;EACA,uCAAA;AACF","sourcesContent":[".button {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 36px;\n  height: 36px;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 8px;\n  background-color: var(--background-color);\n}\n\n.button:hover {\n  background-color: var(--background-color-hover);\n}\n\n.button:focus-visible {\n  background-color: var(--background-color-focus);\n}\n\n.button:active {\n  background-color: var(--background-color-active);\n}\n\n.button:disabled {\n  background-color: var(--background-color-disabled);\n  cursor: default;\n}\n\n.button .icon {\n  fill: var(--color-icon);\n}\n\n.button:disabled .icon {\n  fill: var(--color-icon-disabled);\n}\n\n.theme-1 {\n  --background-color: transparent;\n  --background-color-hover: var(--base-15);\n  --background-color-focus: var(--base-15);\n  --background-color-active: var(--base-17);\n  --background-color-disabled: transparent;\n  --color-icon: var(--base-120);\n  --color-icon-disabled: var(--base-120);\n}\n\n.theme-2 {\n  --background-color: var(--brand-primary-0);\n  --background-color-hover: var(--brand-primary-0);\n  --background-color-focus: var(--brand-primary-0);\n  --background-color-active: var(--brand-primary-0);\n  --background-color-disabled: transparent;\n  --color-icon: var(--base-120);\n  --color-icon-disabled: var(--base-120);\n}\n\n.theme-3 {\n  --background-color: transparent;\n  --background-color-hover: var(--brand-primary-0);\n  --background-color-focus: var(--brand-primary-0);\n  --background-color-active: var(--brand-primary-10);\n  --background-color-disabled: transparent;\n  --color-icon: var(--danger-40);\n  --color-icon-disabled: var(--danger-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `TextFormattingMenuButton__button-a8f475`,
	"icon": `TextFormattingMenuButton__icon-d25ab9`,
	"theme-1": `TextFormattingMenuButton__theme-1-d793cc`,
	"theme1": `TextFormattingMenuButton__theme-1-d793cc`,
	"theme-2": `TextFormattingMenuButton__theme-2-e18968`,
	"theme2": `TextFormattingMenuButton__theme-2-e18968`,
	"theme-3": `TextFormattingMenuButton__theme-3-fdc175`,
	"theme3": `TextFormattingMenuButton__theme-3-fdc175`
};
module.exports = ___CSS_LOADER_EXPORT___;
